










































































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import rest from "@/rest";
// interfaces
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { TrainingLocationVm } from "@/interfaces/TrainingLocationVm";

// Rooms of an organization. Emits "changed" after every change so the parent can reload its room list.
@Component
export default class TrainingLocationsDialog extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop({ required: true, type: Number }) readonly orgId!: number;
  @Prop({ type: String, default: "" }) readonly orgName!: string;

  locations: TrainingLocationVm[] = [];
  form: TrainingLocationVm = this.emptyForm();
  capacity: string | null = "";
  loading = false;
  saving = false;
  valid = true;

  readonly nameRules = [
    (v: string) => !!(v && v.trim()) || "Bitte einen Namen eingeben.",
    (v: string) => (v || "").length <= 100 || "Maximal 100 Zeichen."
  ];
  readonly capacityRules = [(v: string | null) => v === null || v === "" || (/^\d+$/.test(String(v)) && Number(v) >= 1) || "Ganze Zahl ab 1."];

  emptyForm(): TrainingLocationVm {
    return { id: 0, organizationId: this.orgId, name: "", address: "", capacity: null, isActive: true, sessionCount: 0 };
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(show: boolean): Promise<void> {
    if (!show) return;
    this.edit(null);
    await this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    try {
      const params: ParamDictionary = { dictionary: {} };
      params.dictionary!["OrgId"] = this.orgId.toString();
      // On errors the rest wrapper shows the message and returns undefined
      this.locations = (await rest.url("trainingLead/getLocations").post(params)) ?? [];
    } finally {
      this.loading = false;
    }
  }

  edit(location: TrainingLocationVm | null): void {
    this.form = location ? { ...location } : this.emptyForm();
    this.capacity = this.form.capacity === null ? "" : String(this.form.capacity);
    this.$nextTick(() => (this.$refs.form as any)?.resetValidation());
  }

  async save(): Promise<void> {
    if (!(this.$refs.form as any).validate()) return;

    this.saving = true;
    try {
      const vm: TrainingLocationVm = {
        ...this.form,
        organizationId: this.orgId,
        capacity: this.capacity === null || this.capacity === "" ? null : Number(this.capacity)
      };
      const result: TrainingLocationVm | undefined = await rest.url("trainingLead/saveLocation").post(vm);
      if (!result) return;
      await this.load();
      this.edit(null);
      this.$emit("changed");
    } finally {
      this.saving = false;
    }
  }

  async remove(): Promise<void> {
    this.saving = true;
    try {
      const params: ParamDictionary = { dictionary: {} };
      params.dictionary!["LocationId"] = this.form.id.toString();
      const result = await rest.url("trainingLead/deleteLocation").post(params);
      if (result === undefined) return;
      await this.load();
      this.edit(null);
      this.$emit("changed");
    } finally {
      this.saving = false;
    }
  }
}
